// Shared schema.org builders — one source of truth for business details used in JSON-LD.
import { SITE_URL, absoluteUrl, localizedPath } from './langPath';

export const PHONE = '+380937787780';
export const PHONE_DISPLAY = '+38 (093) 778-77-80';
export const GOOGLE_REVIEW_URL = 'https://g.page/r/CVy6JM1uB-lJEAE/review';

const KNOWN_BRANDS = ['DeWalt', 'Makita', 'Bosch', 'Milwaukee', 'Hilti', 'Metabo'];

export function buildLocalBusiness(language = 'uk') {
  const ru = language === 'ru';
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#business`,
    name: 'SmarTOOL',
    description: ru
      ? 'Аренда электроинструмента в Харькове без залога с доставкой. Перфораторы, болгарки, шуруповёрты DeWalt, Bosch, Makita.'
      : 'Оренда електроінструменту в Харкові без застави з доставкою. Перфоратори, болгарки, шуруповерти DeWalt, Bosch, Makita.',
    url: absoluteUrl(localizedPath('/', language)),
    telephone: PHONE,
    image: `${SITE_URL}/og-image.png`,
    logo: `${SITE_URL}/favicon.png`,
    priceRange: ru ? 'от 250 грн/сутки' : 'від 250 грн/доба',
    currenciesAccepted: 'UAH',
    paymentAccepted: 'Cash, Credit Card',
    address: {
      '@type': 'PostalAddress',
      streetAddress: ru ? 'ул. Сумская, 49' : 'вул. Сумська, 49',
      addressLocality: ru ? 'Харьков' : 'Харків',
      addressRegion: ru ? 'Харьковская область' : 'Харківська область',
      postalCode: '61023',
      addressCountry: 'UA',
    },
    geo: { '@type': 'GeoCoordinates', latitude: 49.9935, longitude: 36.2304 },
    areaServed: { '@type': 'City', name: ru ? 'Харьков' : 'Харків' },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59',
    },
  };
}

// A rental, not a product for sale: `Product` + `Offer.price` makes Google show the daily
// rate as a purchase price with "In stock". Rates are per-period UnitPriceSpecifications.
export function buildRentalService({ tool, name, description, url, language = 'uk' }) {
  const ru = language === 'ru';
  const rates = [
    { price: tool.pricePerDay, unitCode: 'DAY', unitText: ru ? 'сутки' : 'доба' },
    { price: tool.pricePerWeek, unitCode: 'WEE', unitText: ru ? 'неделя' : 'тиждень' },
    { price: tool.pricePerNight, unitText: ru ? 'ночь' : 'ніч' },
  ].filter((rate) => rate.price > 0);

  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    serviceType: ru ? 'Аренда электроинструмента' : 'Оренда електроінструменту',
    description,
    image: tool.image,
    url,
    brand: { '@type': 'Brand', name: detectBrand(tool.name?.uk) },
    provider: { '@id': `${SITE_URL}/#business` },
    areaServed: { '@type': 'City', name: ru ? 'Харьков' : 'Харків' },
    offers: {
      '@type': 'Offer',
      businessFunction: 'http://purl.org/goodrelations/v1#LeaseOut',
      url,
      availability: tool.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      priceSpecification: rates.map((rate) => ({
        '@type': 'UnitPriceSpecification',
        priceCurrency: 'UAH',
        ...rate,
      })),
    },
  };
}

// Brand from the tool's display name ("Штроборіз Makita SG125J" → Makita); DeWalt is the fleet default.
export function detectBrand(name) {
  const lower = (name || '').toLowerCase();
  return KNOWN_BRANDS.find((b) => lower.includes(b.toLowerCase())) || 'DeWalt';
}

export function jsonLd(data) {
  return { __html: JSON.stringify(data) };
}
